import { UsersImport } from './Import'
const { RoutesMap, Profile } = UsersImport

const UsersRoute = () => {
    return [
        {
            path: RoutesMap.PROFILE.path,
            element: <Profile />
        },
    ]
}

export default UsersRoute;